module.exports = __webpack_public_path__ + "assets/img/slider-2.ce51ded3.jpg";